import { render, staticRenderFns } from "./AdminDepartment.vue?vue&type=template&id=d3318426&"
import script from "./AdminDepartment.vue?vue&type=script&lang=js&"
export * from "./AdminDepartment.vue?vue&type=script&lang=js&"
import style0 from "./AdminDepartment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminDepartment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports